import { authTypes } from '../auth/types'
import { ClienstValue, ClientsActions, ClientsType, clientsTypes } from './types'

const initialState: ClientsType = {
  clients: {
    start: 0,
    limit: 0,
    total: 0,
    items: [],
  },
  statistics: []
}

const reducer = (state = initialState, action: ClientsActions): ClientsType => {
  const { type, payload } = action

  switch (type) {
    case authTypes.LOGIN_REQUEST: { return initialState }
    case authTypes.LOGOUT_REQUEST: { return initialState }

    case clientsTypes.SET_CLIENTS: {
      return payload as ClientsType
    }

    case clientsTypes.SET_CLIENTS_VALUE: {
      const { attr, value } = payload as ClienstValue
      return {
        ...state,
        [attr]: value
      }
    }


    default:
      return state
  }
}

export default reducer
